import loadFirebase, { getFirebaseApp } from '../firebase';
import { getImpersonationSession } from '../../helpers/impersonation';

let authPromise = null;
const localAuthInstances = new WeakSet();

const authModule = async () => {
    const firebase = await loadFirebase();
    const auth = getFirebaseApp().auth();
    if (process.env.FB_EMULATOR === 'true' && !localAuthInstances.has(auth)) {
        auth.useEmulator('http://127.0.0.1:9099', { disableWarnings: true });
        localAuthInstances.add(auth);
    }
    if (!authPromise) {
        authPromise = getImpersonationSession()
            ? auth.setPersistence(firebase.auth.Auth.Persistence.SESSION).then(() => auth)
            : Promise.resolve(auth);
    }

    return authPromise;
};

export default authModule;
